import React from "react";
import HeroBgAnimation from "../HeroBgAnimation";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  StatusBadge,
  Title,
  TextLoop,
  Span,
  TechStackBadge,
  SubTitle,
  SocialMediaIcons,
  SocialMediaIcon,
  ActionButtons,
  PrimaryButton,
  SecondaryButton,
  HeroRightContainer,
  ImageWrapper,
  GlowingOrb,
  Img,
  FloatingBadgeLeft,
  FloatingBadgeRight,
  HeroInnerContainer,
} from "./HeroStyle";
import HeroImg from "../../images/IMG_20260427_162805_812.jpg.jpeg";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";
import { FiSend, FiFileText } from "react-icons/fi";

const HeroSection = () => {
  return (
    <div id="home">
      <HeroContainer>
        {/* ATMOSPHERIC BACKGROUND: DARK BACKGROUND + SUBTLE NEURAL NETWORK + 3D GLOW / AURORA */}
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>

        <HeroInnerContainer>
          {/* LEFT CONTENT */}
          <HeroLeftContainer id="Left">
            {/* STATUS BADGE */}
            <StatusBadge>
              <span className="dot" />
              Available for Freelance & Full-time Roles
            </StatusBadge>

            {/* MAIN NAME TITLE */}
            <Title>
              Hi 👋, I'm <br />
              <span className="name-gradient">{Bio.name}</span>
            </Title>

            {/* ROLE TYPEWRITER */}
            <TextLoop>
              <span>I am a</span>
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 25,
                    delay: 50,
                  }}
                />
              </Span>
            </TextLoop>

            {/* TECH STACK TICKER BADGE: React • Node • MongoDB • Next.js */}
            <TechStackBadge>
              <span className="tech-highlight">React.js</span>
              <span className="tech-dot">•</span>
              <span className="tech-highlight">Node.js</span>
              <span className="tech-dot">•</span>
              <span className="tech-highlight">MongoDB</span>
              <span className="tech-dot">•</span>
              <span className="tech-highlight">Next.js</span>
              <span className="tech-dot">•</span>
              <span>Express.js</span>
              <span className="tech-dot">•</span>
              <span>Tailwind CSS</span>
            </TechStackBadge>

            <SubTitle>{Bio.description}</SubTitle>

            {/* SOCIAL MEDIA ICONS */}
            <SocialMediaIcons>
              <SocialMediaIcon
                href={Bio.github}
                target="_blank"
                rel="noopener noreferrer"
                title="GitHub"
              >
                <FaGithub />
              </SocialMediaIcon>

              <SocialMediaIcon
                href={Bio.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
              >
                <FaLinkedin />
              </SocialMediaIcon>

              <SocialMediaIcon
                href={Bio.twitter}
                target="_blank"
                rel="noopener noreferrer"
                title="Twitter"
              >
                <FaTwitter />
              </SocialMediaIcon>

              <SocialMediaIcon
                href={Bio.instagram}
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <FaInstagram />
              </SocialMediaIcon>
            </SocialMediaIcons>

            {/* DUAL ACTION BUTTONS */}
            <ActionButtons>
              <PrimaryButton href="#contact">
                <FiSend /> Get in Touch / Hire Me
              </PrimaryButton>

              <SecondaryButton
                href={Bio.resume}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FiFileText /> Download Resume
              </SecondaryButton>
            </ActionButtons>
          </HeroLeftContainer>

          {/* RIGHT PROFILE PICTURE & 3D AURORA HALO */}
          <HeroRightContainer id="Right">
            <ImageWrapper>
              <GlowingOrb />
              <FloatingBadgeLeft>
                ⚡ MERN Stack Pro
              </FloatingBadgeLeft>
              <Img src={HeroImg} alt={`${Bio.name} - Full Stack Developer`} />
              <FloatingBadgeRight>
                🏆 3+ Industry Roles
              </FloatingBadgeRight>
            </ImageWrapper>
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;